import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Loader } from '@googlemaps/js-api-loader';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  ChartDataset,
  ChartOptions,
  ChartType,
  TimeUnit
} from 'chart.js';
import 'chartjs-adapter-moment';
import { saveAs } from 'file-saver';
import { Observable } from 'rxjs';
import { Erb } from 'src/app/core/models/erb.model';
import { UserAudit } from 'src/app/core/models/userAudit';
import { AuthService } from 'src/app/core/services/auth.service';
import { ErbService } from 'src/app/core/services/erb.service';
import { PositionsService } from 'src/app/core/services/positions.service';
import { ToastService } from 'src/app/shared/widget/notification/toast-service';
import { environment } from 'src/environments/environment';
import {
  Evento,
  Evento_OrigemMensagem,
  Evento_TiposEventos
} from '../../../../assets/proto-ts/evento';

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss'],
  providers: [DatePipe],
})

//TODO: Apresentar todos os dados dos eventos
//TODO: Filtro de eventos
//TODO: Deixar uma apresentacao bonita da posicao, formatar
export class EventsComponent implements OnInit, AfterViewInit {
  constructor(
    private positionService: PositionsService,
    public datePipe: DatePipe,
    private modalService: NgbModal,
    public toastService: ToastService,
    private erbService: ErbService,
    private authService: AuthService
  ) {
    this.userAudit = new UserAudit(
      this.authService.currentUserValue,
      'packets/events'
    );
  }
  options: google.maps.MapOptions = {
    center: { lat: -13.7972945, lng: -59.6173487 },
    zoom: 4,
  };

  loader = new Loader({
    apiKey: environment.googleMaps.key,
    version: 'weekly',
  });

  userAudit: UserAudit;
  apiLoaded: Observable<boolean> | undefined;

  maps: any;
  public positionEventJson: any[] = [];
  public positionEventJsonList: any[] = [];

  public positionPrepared: any[] = [];
  public serial: string = '';

  public prettyEvent: string = '0';
  public collapseAllCardEvents: boolean = true;
  public textHighlight: string = '';
  public circularProgressiveWait: boolean = false;

  public tableCountEventHTMLString = '';
  countEventType: any = {};
  btnMinimizeCountEventTypeWindow: boolean = true;

  jsonEventsGrid: any = {};
  filterGridEvents: { [key: string]: { [key: string]: boolean } } = {};
  filterGridEventsSelect: string[] = [];
  modalInstance: any = undefined;
  isExportingExcel: boolean = false;

  lineBetweenMarkers: number = 0;
  erbsFlag: boolean = false;
  logicNOT: boolean = false;
  mapActiveFlag: boolean = true;
  markerFilterLoRaP2PGpsLatFlag: boolean = false;
  filterEventList = [{ id: -1, name: 'TODOS' }];
  events: [{ id: number; name: string }] = [{ id: -1, name: 'TODOS' }];
  messageOrigin: [{ id: number; name: string }] = [{ id: -1, name: 'TODOS' }];
  integrator: [{ id: number; name: string }] = [{ id: -1, name: 'TODOS' }];

  filterEventsSelect: number[] = [-1];
  filterMessageOriginSelect: number[] = [-1];
  hasIntegrator: boolean = false;
  hasTagSource: boolean = false;
  filterTagSourceSelect = 'todos';
  tagSources: { id: string; name: string }[] = [
    { id: 'todos', name: 'TODOS' },
    { id: 'apple', name: 'apple' },
    { id: 'google', name: 'google' },
  ];

  selected: [number] = [-1];

  graphField: string[] = [];
  graphFieldSelect: string = 'tipo_evento';
  tableRows: any = [];
  tableColumns: any = [];

  lineCoordinates : LineCoordinate [] = [];
  lineCoordinatesMessageOriginLatLng: google.maps.LatLng[][] = [];

  lineCoordinatesMessageOrigin: string[] = [];
  headers: string[] = [];
  zoom: number = 15;

  polylines: google.maps.Polyline[] = [];
  markers: google.maps.Marker[] = [];
  markersTowers: google.maps.Marker[] = [];
  towersCircle: google.maps.Circle[] = [];
  markersLoRaWAN: google.maps.Circle[] = [];
  towersAzimuth: google.maps.Polygon[] = [];

  filterSequenceNumber: boolean = true;

  // Graph
  public barChartOptions: ChartOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
      },
      datalabels: {
        display: true,
        anchor: 'end',
        align: 'end',
        font: {
          size: 20,
        },
      },
    },
  };
  public barChartLabels: string[] = [];
  public barChartType: ChartType = 'bar';
  public barChartLegend = true;
  public barChartPlugins = [];
  public barChartData: ChartDataset[] = [];
  public heightGraph = '300px';
  // End Graph

  // Graph Line
  public lineChartDataBattery: ChartDataset[] = [];
  public lineChartLabelsBattery: Date[] = [];
  public lineChartFilterDetectionP2PBattery: boolean = true;
  public lineChartFilterOriginP2PBattery: boolean = false;
  lineChartFilterTimeEstimatedBattery: boolean = false;
  lineChartFilterPercentBattery: boolean = false;
  lineChartBatteryIgn: boolean = false;
  lineChartFilterInternalBattery: boolean = true;
  lineChartDeconectBattery: boolean = false;

  public lineChartData: ChartDataset[][] = [[], [], []];
  public lineChartLabels: Date[][] = [[], [], []];
  lineChartOptionsStepSize: number = 1;
  lineChartOptionsStepUnit: TimeUnit = 'minute';
  public lineChartOptions: ChartOptions = {
    responsive: true,
    scales: {
      x: {
        type: 'time',
        time: {
          unit: this.lineChartOptionsStepUnit,
          stepSize: this.lineChartOptionsStepSize,
          tooltipFormat: 'DD/MM/YYYY HH:mm:ss',
          displayFormats: {
            millisecond: 'HH:mm:ss.SSS',
            second: 'DD/MM/YYYY HH:mm:ss',
            minute: 'DD/MM/YYYY HH:mm',
            hour: 'DD/MM/YYYY HH',
            day: 'DD/MM/YYYY',
            week: 'DD/MM/YYYY',
            month: 'MM/YYYY',
            quarter: 'Q/YYYY',
            year: 'YYYY',
          },
        },
      },
      // y: {
      //   min: -10,
      //   max: 10,
      // },
    },
  };
  public lineChartFilterDetectionP2PGsmGps: boolean = true;
  public lineChartFilterOriginP2PGsmGps: boolean = false;

  public lineChartColors: any[] = [
    {
      borderColor: 'black',
      backgroundColor: 'rgba(255,0,0,0.3)',
    },
  ];
  public lineChartLegend = true;
  public lineChartType: ChartType = 'line';
  public lineChartPlugins = [];

  // Graph Line

  // TableCountEventModal
  public countEventTable: countEventTable[] = [];
  public tableCountEventHTML: string[] = [];
  // End TableCountEventModal

  dateStart: string = '';
  dateEnd: string = '';

  changeUnitLineChart() {
    this.lineChartOptions = {
      responsive: true,
      scales: {
        x: {
          type: 'time',
          time: {
            unit: this.lineChartOptionsStepUnit,
            stepSize: this.lineChartOptionsStepSize,
            tooltipFormat: 'DD/MM/YYYY HH:mm:ss',
            displayFormats: {
              millisecond: 'HH:mm:ss.SSS',
              second: 'DD/MM/YYYY HH:mm:ss',
              minute: 'DD/MM/YYYY HH:mm',
              hour: 'DD/MM/YYYY HH',
              day: 'DD/MM/YYYY',
              week: 'DD/MM/YYYY',
              month: 'MM/YYYY',
              quarter: 'Q/YYYY',
              year: 'YYYY',
            },
          },
        },
      },
    };
  }

  getItemToFilter(itemFilter: any, partialProto: any) {
    let item: [{ id: number; name: string }] = itemFilter;
    for (const key in Object(partialProto)) {
      if (Number(key) || key == '0') {
        item.push({
          id: Number(key),
          name: Object(partialProto)[key],
        });
      }
    }
    return item;
  }

  ngOnInit() {
    this.dateStart = this.datePipe.transform(
      new Date(),
      'yyyy-MM-ddT00:00:00'
    )!;
    this.dateEnd = this.datePipe.transform(new Date(), 'yyyy-MM-ddT23:59:59')!;
    this.events = this.getItemToFilter(this.events, Evento_TiposEventos);
    this.messageOrigin = this.getItemToFilter(
      this.messageOrigin,
      Evento_OrigemMensagem
    );
  }

  changeLogicFilter() {
    this.logicNOT = !this.logicNOT;
    this.getEventsFilter(
      this.filterEventsSelect,
      this.filterMessageOriginSelect
    );
    this.processCountEventType();
  }

  preventDropdownClose(event: Event) {
    event.stopPropagation();
  }

  isTagEvent(event: any): boolean {
    const hardware = String(event?.rastreador?.versao_hardware ?? '').toUpperCase();
    if (hardware.startsWith('TAG')) {
      return true;
    }
    return this.tagEventSource(event) !== '';
  }

  onTagSourceChange(selected: any): void {
    this.filterTagSourceSelect = this.tagSourceOptionId(selected);
    this.getEventsFilter(
      this.filterEventsSelect,
      this.filterMessageOriginSelect
    );
  }

  tagSourceOptionId(selected: any): string {
    let raw = selected;
    if (selected != null && typeof selected === 'object') {
      raw =
        selected.id ??
        selected.$ngOptionValue ??
        (typeof selected.value === 'object'
          ? selected.value?.id
          : selected.value) ??
        selected.name ??
        selected.label;
    }
    const id = String(raw ?? '')
      .replace(/<[^>]*>/g, '')
      .trim()
      .toLowerCase();
    if (id === 'apple' || id === 'google' || id === 'todos') {
      return id;
    }
    return 'todos';
  }

  tagEventSource(event: any): string {
    return this.sourceFromMotivo(event?.rastreador?.motivo_envio);
  }

  private sourceFromMotivo(motivo: any, serialized = false): string {
    if (motivo == null) {
      return '';
    }
    if (Array.isArray(motivo)) {
      for (const item of motivo) {
        const source = this.sourceFromMotivo(item);
        if (source !== '') {
          return source;
        }
      }
      return '';
    }
    if (typeof motivo === 'string') {
      const text = motivo.trim();
      if (text.startsWith('{')) {
        try {
          return this.sourceFromMotivo(JSON.parse(text));
        } catch (error) {
          return '';
        }
      }
      const match = /^"?source"?\s*[:=]\s*"?([^",}]+)"?$/i.exec(text);
      return match ? match[1].trim().toLowerCase() : '';
    }
    if (typeof motivo === 'object') {
      const key = Object.keys(motivo).find(
        (item) => item.toLowerCase() === 'source'
      );
      const source = key == null ? null : motivo[key];
      if (source != null && typeof source !== 'object') {
        return String(source).trim().toLowerCase();
      }
      if (!serialized) {
        try {
          return this.sourceFromMotivo(JSON.parse(JSON.stringify(motivo)), true);
        } catch (error) {
          return '';
        }
      }
    }
    return '';
  }

  updateTagSourceAvailability() {
    this.hasTagSource = this.positionEventJson.some((event) =>
      this.isTagEvent(event)
    );
    if (!this.hasTagSource) {
      this.filterTagSourceSelect = 'todos';
    }
  }

  hasActiveTagSourceFilter(): boolean {
    return (
      this.hasTagSource &&
      this.filterTagSourceSelect != null &&
      this.filterTagSourceSelect !== 'todos'
    );
  }

  mapCenterEvent(): any {
    return (
      this.positionEventJsonList.find(
        (item: any) => item?.gps?.latitude != 0 && item?.gps?.longitude != 0
      ) ?? this.positionEventJson[0]
    );
  }

  getEventsFilter(eventId: any, originId: any) {
    this.filterTagSourceSelect = this.tagSourceOptionId(this.filterTagSourceSelect);
    if (this.filterEventsSelect.length == 0) {
      this.filterEventsSelect = [-1];
      eventId = [-1];
    } else if (this.filterEventsSelect.length > 1) {
      this.filterEventsSelect = this.filterEventsSelect.filter((item: any) => {
        return item != -1;
      });
      eventId = this.filterEventsSelect;
    }

    if (this.filterMessageOriginSelect.length == 0) {
      this.filterMessageOriginSelect = [-1];
      originId = [-1];
    } else if (this.filterMessageOriginSelect.length > 1) {
      this.filterMessageOriginSelect = this.filterMessageOriginSelect.filter(
        (item: any) => {
          return item != -1;
        }
      );
      originId = this.filterMessageOriginSelect;
    }
    let conditionEvent =
      !eventId ||
      (eventId.length === 1 && eventId[0] === -1) ||
      eventId.includes(-1);
    let conditionOrigin =
      !originId ||
      (originId.length === 1 && originId[0] === -1) ||
      originId.includes(-1);
    let conditionTagSource =
      !this.hasTagSource || this.filterTagSourceSelect === 'todos';

    if (
      conditionEvent &&
      conditionOrigin &&
      conditionTagSource
    ) {
      this.positionEventJsonList = this.positionEventJson;
      this.drawingMapAfterFilter(this.positionEventJsonList);
    } else {
      let positionEventsFilter: any[] = this.positionEventJson;
      if (!conditionEvent) {
        let messageEventFilterName: string[] = [];
        eventId.forEach((itemEventSelect: number) => {
          let eventName =
            this.events.filter((item) => {
              return item.id == itemEventSelect;
            })[0].name ?? '';

          messageEventFilterName.push(eventName);
        });
        positionEventsFilter = positionEventsFilter.filter((item: any) => {
          if (!this.logicNOT) {
            return messageEventFilterName.includes(item.tipo_evento);
          } else {
            return !messageEventFilterName.includes(item.tipo_evento);
          }
        });
      }
      if (!conditionOrigin) {
        let messageOriginFilterName: string[] = [];
        originId.forEach((itemOriginSelect: number) => {
          let originName =
            this.messageOrigin.filter((item) => {
              return item.id == itemOriginSelect;
            })[0].name ?? '';

          messageOriginFilterName.push(originName);
        });
        positionEventsFilter = positionEventsFilter.filter((item: any) => {
          return messageOriginFilterName.includes(item.origem_mensagem);
        });
      }
      if (!conditionTagSource) {
        const selectedSource = this.filterTagSourceSelect;
        positionEventsFilter = positionEventsFilter.filter((item: any) => {
          return this.tagEventSource(item) === selectedSource;
        });
      }
      this.positionEventJsonList = positionEventsFilter;
      this.drawingMapAfterFilter(this.positionEventJsonList);
    }
    this.processCountEventType();
  }

  dostuff(b64Data: string): Uint8Array {
    const byteCharacters = atob(b64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return byteArray;
  }

  epochToDateTime(eventJson: any) {
    eventJson.data_hora_evento = this.datePipe.transform(
      new Date(eventJson.data_hora_evento).toUTCString(),
      'dd-MM-yyyy HH:mm:ss'
    )!;
    eventJson.data_hora_recebimento = this.datePipe.transform(
      new Date(eventJson.data_hora_recebimento).toUTCString(),
      'dd-MM-yyyy HH:mm:ss'
    )!;
    eventJson.data_hora_armazenamento = this.datePipe.transform(
      new Date(eventJson.data_hora_armazenamento).toUTCString(),
      'dd-MM-yyyy HH:mm:ss'
    )!;
    if (eventJson.data_hora_temperatura) {
      // data_hora_temperatura vem do backend em segundos (epoch), diferente dos demais campos que vem em milissegundos
      eventJson.data_hora_temperatura = this.datePipe.transform(
        new Date(eventJson.data_hora_temperatura * 1000).toUTCString(),
        'dd-MM-yyyy HH:mm:ss'
      )!;
    }

    return eventJson;
  }

  cleanMap() {}
  processCountEventType() {
    this.countEventType = {};
    this.countEventType = { messageOrigin: ['Total'] };

    this.positionEventJsonList.forEach((element) => {
      const eventOrigin = element.origem_mensagem;
      const eventType = element.tipo_evento;
      if (!this.countEventType['messageOrigin'].includes(eventOrigin)) {
        this.countEventType['messageOrigin'].push(eventOrigin);
      }
      if (!this.countEventType[eventType]) {
        this.countEventType[eventType] = {};
        this.countEventType[eventType]['Total'] = 0;
      }
      if (!this.countEventType[eventType][eventOrigin]) {
        this.countEventType[eventType][eventOrigin] = 0;
      }
      this.countEventType[eventType][eventOrigin]++;
      this.countEventType[eventType]['Total']++;
    });

    this.countEventType['messageOrigin'] = this.countEventType[
      'messageOrigin'
    ].sort((a: string, b: string) => b.localeCompare(a));
    if (Object.keys(this.countEventType).length > 0) {
      this.btnMinimizeCountEventTypeWindow = false;
    }
  }

  getKeys(item: any, orderAsc?: boolean) {
    var keys = Object.keys(item);
    if (orderAsc != undefined) {
      if (orderAsc) {
        keys = keys.sort((a, b) => a.localeCompare(b));
      } else {
        keys = keys.sort((a, b) => b.localeCompare(a));
      }
    }
    return keys;
  }
  getValue(item: any, key: string, subKey?: string) {
    if (subKey) {
      return Object(item)[key][subKey];
    }
    return Object(item)[key];
  }

  searchEvents(): void {
    // window.resizeTo(window.innerWidth, window.innerHeight);
    this.initMap();
    this.headers = [];
    this.modalInstance = undefined;
    this.countEventType = {};
    this.lineCoordinatesMessageOrigin = [];
    this.lineCoordinatesMessageOriginLatLng = [];
    this.positionEventJson = [];
    this.positionEventJsonList = [];
    this.polylines = [];
    this.lineCoordinates = [];
    this.barChartData = [];
    this.barChartLabels = [];
    this.countEventTable = [];
    this.tableCountEventHTML = [];
    this.lineChartData = [[], [], []];
    this.lineChartLabels = [[], [], []];
    this.markers = [];
    this.tableCountEventHTMLString = '';
    this.circularProgressiveWait = true;
    var dateStartEpoch = Date.parse(this.dateStart).toString();
    var dateEndEpoch = Date.parse(this.dateEnd).toString();
    let integratorLst: string[] = [];
    this.integrator = [{ id: -1, name: 'TODOS' }];
    this.hasTagSource = false;
    this.jsonEventsGrid = [];
    this.positionService
      .getPositionJson(
        this.serial.trim(),
        dateStartEpoch,
        dateEndEpoch,
        this.userAudit
      )
      .subscribe(
        (response: [any]) => {          
          if (response != null && this.positionEventJson.length == 0) {
            const allEmpty = response.every(inner => Array.isArray(inner) && inner.length === 0);
            if (response.length > 0 && !allEmpty) {
              var positionEvent = response;
              positionEvent.forEach((item : any) => {
                item
                  .slice()
                  .reverse()
                  .forEach((event: Evento) => {
                    var a = Evento.fromJSON(event);
                    let eventJsonParseDate: any = this.epochToDateTime(
                      Object(event)
                    );
                    try {
                      eventJsonParseDate.revgeo.bairro = decodeURI(
                        eventJsonParseDate.revgeo.bairro
                      );
                      eventJsonParseDate.revgeo.logradouro = decodeURI(
                        eventJsonParseDate.revgeo.logradouro
                      );
                      eventJsonParseDate.revgeo.municipio = decodeURI(
                        eventJsonParseDate.revgeo.municipio
                      );
                    } catch (error) {
                      console.log(error);
                    }
                    if (this.mapActiveFlag) {
                      if (
                        eventJsonParseDate.gps.latitude != 0 &&
                        eventJsonParseDate.gps.longitude != 0
                      ) {
                        this.setMakerPosition(eventJsonParseDate);
                      }
                    }
                    if (
                      eventJsonParseDate.rastreador.fabricante.toLowerCase() ==
                      'integracao'
                    ) {
                      if (
                        !integratorLst.includes(
                          eventJsonParseDate.rastreador.versao_hardware
                        )
                      ) {
                        integratorLst.push(
                          eventJsonParseDate.rastreador.versao_hardware
                        );
                      }
                    }
                    this.positionEventJson.push(eventJsonParseDate);
                  });
                this.positionEventJsonList = this.positionEventJson;
                integratorLst.forEach((integratorItem: string) => {
                  this.integrator.push({
                    id: this.integrator.length - 2,
                    name: integratorItem,
                  });
                });
                if (integratorLst.length > 0) {
                  this.hasIntegrator = true;
                } else {
                  this.hasIntegrator = false;
                }
                this.updateTagSourceAvailability();

                if (
                  (this.filterEventsSelect != undefined &&
                    this.filterEventsSelect != null &&
                    this.filterEventsSelect.length > 0 &&
                    !this.filterEventsSelect.includes(-1)) ||
                  (this.filterMessageOriginSelect != undefined &&
                    this.filterMessageOriginSelect != null &&
                    this.filterMessageOriginSelect.length > 0 &&
                    !this.filterMessageOriginSelect.includes(-1)) ||
                  this.hasActiveTagSourceFilter()
                ) {
                  this.getEventsFilter(
                    this.filterEventsSelect,
                    this.filterMessageOriginSelect
                  );
                }
                if (this.mapActiveFlag) {
                  this.lineBetweenPoints();
                  const centerEvent = this.mapCenterEvent();
                  this.maps.setCenter({
                    lat: centerEvent.gps.latitude,
                    lng: centerEvent.gps.longitude,
                  });
                  this.maps.setZoom(this.zoom);
                }                 
                this.processCountEventType();
                this.circularProgressiveWait = false;
              }
            )
            } else {
              this.circularProgressiveWait = false;
              this.toastService.show('Sem resultados', {
                classname: 'bg-success text-center text-white',
                delay: 2500,
              });
            }
          }
        },
        (error: HttpErrorResponse) => {
          //alert(error.message);
          this.toastService.show(
            error?.status === 403
              ? 'Sessão expirada. Faça login novamente.'
              : 'Erro ao pesquisar - ' + error.message,
            {
            classname: 'bg-danger text-center text-white',
            delay: 10000,
          });
          this.circularProgressiveWait = false;
        }
      );
  }

  searchEventsWithProtoEvent(): void {
    // window.resizeTo(window.innerWidth, window.innerHeight);
    this.initMap();
    this.headers = [];
    this.modalInstance = undefined;
    this.countEventType = {};
    this.lineCoordinatesMessageOrigin = [];
    this.lineCoordinatesMessageOriginLatLng = [];
    this.positionEventJson = [];
    this.positionEventJsonList = [];
    this.polylines = [];
    this.lineCoordinates = [];
    this.barChartData = [];
    this.barChartLabels = [];
    this.countEventTable = [];
    this.tableCountEventHTML = [];
    this.lineChartData = [[], [], []];
    this.lineChartLabels = [[], [], []];
    this.markers = [];
    this.tableCountEventHTMLString = '';
    this.circularProgressiveWait = true;
    var dateStartEpoch = Date.parse(this.dateStart).toString();
    var dateEndEpoch = Date.parse(this.dateEnd).toString();
    let integratorLst: string[] = [];
    this.integrator = [{ id: -1, name: 'TODOS' }];
    this.hasTagSource = false;
    this.jsonEventsGrid = [];
    this.positionService
      .getPositionJsonWithProtoEvents(
        this.serial.trim(),
        dateStartEpoch,
        dateEndEpoch,
        this.userAudit
      )
      .subscribe(
        (response: [any]) => {
          if (response != null && this.positionEventJson.length == 0) {
            const allEmpty = response.every(inner => Array.isArray(inner) && inner.length === 0);
            if (response.length > 0 && !allEmpty) {
              var positionEvent = response;
              positionEvent.forEach((item : any) => {
              item
                .slice()
                .reverse()
                .forEach((event: Evento) => {
                  var a = Evento.fromJSON(event);
                  let eventJsonParseDate: any = this.epochToDateTime(
                    Object(event)
                  );
                  try {
                    eventJsonParseDate.revgeo.bairro = decodeURI(
                      eventJsonParseDate.revgeo.bairro
                    );
                    eventJsonParseDate.revgeo.logradouro = decodeURI(
                      eventJsonParseDate.revgeo.logradouro
                    );
                    eventJsonParseDate.revgeo.municipio = decodeURI(
                      eventJsonParseDate.revgeo.municipio
                    );
                  } catch (error) {
                    console.log(error);
                  }
                  if (this.mapActiveFlag) {
                    if (
                      eventJsonParseDate.gps.latitude != 0 &&
                      eventJsonParseDate.gps.longitude != 0
                    ) {
                      this.setMakerPosition(eventJsonParseDate);
                    }
                  }
                  if (
                    eventJsonParseDate.rastreador.fabricante.toLowerCase() ==
                    'integracao'
                  ) {
                    if (
                      !integratorLst.includes(
                        eventJsonParseDate.rastreador.versao_hardware
                      )
                    ) {
                      integratorLst.push(
                        eventJsonParseDate.rastreador.versao_hardware
                      );
                    }
                  }

                  this.positionEventJson.push(eventJsonParseDate);
                });
              this.positionEventJsonList = this.positionEventJson;
              integratorLst.forEach((integratorItem: string) => {
                this.integrator.push({
                  id: this.integrator.length - 2,
                  name: integratorItem,
                });
              });
              if (integratorLst.length > 0) {
                this.hasIntegrator = true;
              } else {
                this.hasIntegrator = false;
              }
              this.updateTagSourceAvailability();

              if (
                (this.filterEventsSelect != undefined &&
                  this.filterEventsSelect != null &&
                  this.filterEventsSelect.length > 0 &&
                  !this.filterEventsSelect.includes(-1)) ||
                (this.filterMessageOriginSelect != undefined &&
                  this.filterMessageOriginSelect != null &&
                  this.filterMessageOriginSelect.length > 0 &&
                  !this.filterMessageOriginSelect.includes(-1)) ||
                this.hasActiveTagSourceFilter()
              ) {
                this.getEventsFilter(
                  this.filterEventsSelect,
                  this.filterMessageOriginSelect
                );
              }
              if (this.mapActiveFlag) {
                this.lineBetweenPoints();
                const centerEvent = this.mapCenterEvent();
                this.maps.setCenter({
                  lat: centerEvent.gps.latitude,
                  lng: centerEvent.gps.longitude,
                });
                this.maps.setZoom(this.zoom);
              }
              this.processCountEventType();
              this.circularProgressiveWait = false;
              })
            } else {
              this.circularProgressiveWait = false;
              this.toastService.show('Sem resultados', {
                classname: 'bg-success text-center text-white',
                delay: 2500,
              });
            }
          }
        },
        (error: HttpErrorResponse) => {
          //alert(error.message);
          this.toastService.show(
            error?.status === 403
              ? 'Sessão expirada. Faça login novamente.'
              : 'Erro ao pesquisar - ' + error.message,
            {
            classname: 'bg-danger text-center text-white',
            delay: 10000,
          });
          this.circularProgressiveWait = false;
        }
      );
  }

  drawingMapAfterFilter(positions: any) {
    if (this.positionEventJson.length > 0 && this.mapActiveFlag) {
      this.circularProgressiveWait = true;
      this.initMap();
      this.barChartData = [];
      this.barChartLabels = [];
      this.countEventTable = [];
      this.tableCountEventHTML = [];
      this.lineChartData = [[], [], []];
      this.lineChartLabels = [[], [], []];
      this.tableCountEventHTMLString = '';
      this.markers = [];
      positions.forEach((item: any) => {
        if (item.gps.latitude != 0 && item.gps.longitude != 0) {
          this.setMakerPosition(item);
        }
      });
      this.lineBetweenPoints();
      const centerEvent =
        positions.find(
          (item: any) => item?.gps?.latitude != 0 && item?.gps?.longitude != 0
        ) ?? this.positionEventJson[0];
      this.maps.setCenter({
        lat: centerEvent.gps.latitude,
        lng: centerEvent.gps.longitude,
      });
      this.maps.setZoom(this.zoom);
      this.circularProgressiveWait = false;
    }
  }

  setMakerPosition(positionEvent: any, loraWANWithGpsAux?: boolean) {
    let loraWANWithGps = loraWANWithGpsAux ?? false;
    if (this.lineBetweenMarkers == 0) {
        this.lineCoordinates.push({
          numero_serie: positionEvent.rastreador.numero_serie,
          point: new google.maps.LatLng({
            lat: positionEvent.gps.latitude,
            lng: positionEvent.gps.longitude,
          })
        });
    } else if (this.lineBetweenMarkers == 1) {
      if (
        positionEvent.origem_mensagem == 'GSM' ||
        positionEvent.origem_mensagem == 'REDE_4G' ||
        loraWANWithGps
      ) {
        this.lineCoordinates.push({
          numero_serie: positionEvent.numero_serie,
          point: new google.maps.LatLng({
            lat: positionEvent.gps.latitude,
            lng: positionEvent.gps.longitude,
          })
        });
      }
    } else if (this.lineBetweenMarkers == 2) {
      if (
        !this.lineCoordinatesMessageOrigin.includes(
          `${String(positionEvent.origem_mensagem)}_${
            positionEvent.numero_sequencial
          }`
        )
      ) {
        this.lineCoordinatesMessageOrigin.push(
          `${String(positionEvent.origem_mensagem)}_${
            positionEvent.numero_sequencial
          }`
        );
        this.lineCoordinatesMessageOriginLatLng.push([]);
        this.lineCoordinatesMessageOriginLatLng[
          this.lineCoordinatesMessageOriginLatLng.length - 1
        ].push(
          new google.maps.LatLng({
            lat: positionEvent.gps.latitude,
            lng: positionEvent.gps.longitude,
          })
        );
      } else {
        let index = this.lineCoordinatesMessageOrigin.findIndex(
          (itemIndex: String) => {
            return (
              itemIndex ==
              `${String(positionEvent.origem_mensagem)}_${
                positionEvent.numero_sequencial
              }`
            );
          }
        );
        this.lineCoordinatesMessageOriginLatLng[index].push(
          new google.maps.LatLng({
            lat: positionEvent.gps.latitude,
            lng: positionEvent.gps.longitude,
          })
        );
      }
    } else if (this.lineBetweenMarkers == 3) {
    }

    var color = 'blue';

    if (positionEvent.flags.posicao_online) {
      if (positionEvent.gps.fixado) {
        color = 'blue';
      } else {
        color = 'black';
      }
    } else if (positionEvent.gps.fixado) {
      color = 'red';
    } else {
      color = 'purple';
    }
    let proa = positionEvent.gps.proa;
    let icon = '';
    if (proa == -1) {
      icon = `../../../../assets/images/arrows/${color}_circle.png`;
    } else {
      if (
        Number(positionEvent.gps.proa) < 0 ||
        Number(positionEvent.gps.proa) > 360
      ) {
        proa = 0;
      }
      icon = `../../../../assets/images/arrows/${color}_arrow_${String(
        Number(proa).toFixed(0)
      )}.png`;
    }

    var reasonEvent = '';
    try {
      reasonEvent = positionEvent.rastreador.motivo_envio.join(',');
    } catch (error) {}

    let marker: any = undefined;
    let markerLoRaP2PAux: any = undefined;
    let infowindowLoRaP2PAux: any = undefined;
    let infowindow: any;
    if (positionEvent.origem_mensagem == 'LORA_P2P') {
      marker = new google.maps.Marker({
        position: {
          lat: positionEvent.p2p.latitude,
          lng: positionEvent.p2p.longitude,
        },
        icon: '../../../../assets/images/carrinho-p2p.png',
        title: `<p><span style="color: #ff0000;"><strong>${positionEvent.dataHoraEvento}</strong></span></p>`,
      });

      infowindow = new google.maps.InfoWindow({
        content: ` <div style="line-height: 0.5;">
        <br></br>
        <p><span style="color: #ff0000;"><strong>${
          positionEvent.data_hora_evento
        }</strong></span></p>
        <p><strong>Evento:</strong> ${positionEvent.p2p.motivo ?? ''}</p>
        <p><strong>Num.Seq:</strong> ${positionEvent.numero_sequencial}</p>
        <p><strong>Rssi:</strong> ${positionEvent.p2p.rssi ?? ''}</p>
        <p><strong>SNR:</strong> ${positionEvent.p2p.snr ?? ''}</p>
        <p><strong>Lat:</strong> ${positionEvent.p2p.latitude}</p>
        <p><strong>Long:</strong> ${positionEvent.p2p.longitude}</p>
        <p><strong>Dispositivo que detectou:</strong> ${
          positionEvent.p2p.numero_serie ?? ''
        }</p>
        <p><strong>OrigemMensagem:</strong> ${
          positionEvent.origem_mensagem ?? ''
        }</p>
        </div>
        `,
      });
      let p2pequalgps =
        positionEvent.gps.latitude != positionEvent.p2p.latitude &&
        positionEvent.gps.longitude != positionEvent.p2p.longitude
          ? true
          : false;
      if (this.markerFilterLoRaP2PGpsLatFlag && p2pequalgps) {
        markerLoRaP2PAux = new google.maps.Marker({
          position: {
            lat: positionEvent.gps.latitude,
            lng: positionEvent.gps.longitude,
          },
          icon: { url: icon, anchor: new google.maps.Point(12, 12) },
          opacity: 0.5,
          title: `<p><span style="color: #ff0000;"><strong>${positionEvent.dataHoraEvento}</strong></span></p>`,
          optimized: true,
        });

        infowindowLoRaP2PAux = new google.maps.InfoWindow({
          content: ` <div style="line-height: 0.5;">
        <br></br>
        <p><span style="color: #ff0000;"><strong>${
          positionEvent.data_hora_evento
        }</strong></span></p>
        <p><strong>Dispositivo DETECTADO</p>
        <p><strong>Evento:</strong> ${positionEvent.tipo_evento}</p>
        <p><strong>Num.Seq:</strong> ${positionEvent.numero_sequencial}</p>
        <p><strong>MotivoGerador:</strong> ${reasonEvent}</p>
        <p><strong>Lat:</strong> ${positionEvent.gps.latitude}</p>
        <p><strong>Long:</strong> ${positionEvent.gps.longitude}</p>
        <p><strong>Sat:</strong> ${positionEvent.gps.numero_satelites}</p>
        <p><strong>GpsFix:</strong> ${positionEvent.gps.fixado}</p>
        <p><strong>Ignicao:</strong> ${positionEvent.flags.ignicao}</p>
        <p><strong>PosicaoOnline:</strong>${
          positionEvent.flags.posicao_online
        }</p>
        <p><strong>Velocidade:</strong> ${positionEvent.gps.velocidade}</p>
        <p><strong>OrigemMensagem:</strong> ${
          positionEvent.origem_mensagem ?? ''
        }</p>
        </div>
        `,
        });
      }
    } else if (positionEvent.origem_mensagem == 'LORA_WAN' && !loraWANWithGps) {
      marker = new google.maps.Marker({
        position: {
          lat: positionEvent.p2p.latitude,
          lng: positionEvent.p2p.longitude,
        },
        icon: '../../../../assets/images/tower.png',
        title: `<p><span style="color: #ff0000;"><strong>${positionEvent.dataHoraEvento}</strong></span></p>`,
      });

      infowindow = new google.maps.InfoWindow({
        content: ` <div style="line-height: 0.5;">
        <br></br>
        <p><span style="color: #ff0000;"><strong>${
          positionEvent.data_hora_evento
        }</strong></span></p>
        <p><strong>Evento:</strong> ${positionEvent.p2p.motivo ?? ''}</p>
        <p><strong>Num.Seq:</strong> ${positionEvent.numero_sequencial}</p>
        <p><strong>Rssi:</strong> ${positionEvent.p2p.rssi ?? ''}</p>
        <p><strong>SNR:</strong> ${positionEvent.p2p.snr ?? ''}</p>
        <p><strong>Lat:</strong> ${positionEvent.p2p.latitude}</p>
        <p><strong>Long:</strong> ${positionEvent.p2p.longitude}</p>
        <p><strong>OrigemMensagem:</strong> ${
          positionEvent.origem_mensagem ?? ''
        }</p>
        </div>
        `,
      });
      try {
        if (
          positionEvent.gps.latitude != positionEvent.p2p.latitude &&
          positionEvent.gps.longitude != positionEvent.p2p.longitude
        ) {
          this.setMakerPosition(positionEvent, true);
        }
      } catch (erro: any) {}
    } else if (
      positionEvent.origem_mensagem != 'LORA_P2P' &&
      positionEvent.origem_mensagem != 'LORAWAN'
    ) {
      marker = new google.maps.Marker({
        position: {
          lat: positionEvent.gps.latitude,
          lng: positionEvent.gps.longitude,
        },
        icon: { url: icon, anchor: new google.maps.Point(12, 12) },
        title: `<p><span style="color: #ff0000;"><strong>${positionEvent.dataHoraEvento}</strong></span></p>`,
        optimized: true,
      });

      infowindow = new google.maps.InfoWindow({
        content: ` <div style="line-height: 0.5;">
        <br></br>
        <p><span style="color: #ff0000;"><strong>${
          positionEvent.data_hora_evento
        }</strong></span></p>
        <p><strong>Serial:</strong> ${positionEvent.rastreador.numero_serie}</p>
        <p><strong>Evento:</strong> ${positionEvent.tipo_evento}</p>
        <p><strong>Num.Seq:</strong> ${positionEvent.numero_sequencial}</p>
        <p><strong>MotivoGerador:</strong> ${reasonEvent}</p>
        <p><strong>Lat:</strong> ${positionEvent.gps.latitude}</p>
        <p><strong>Long:</strong> ${positionEvent.gps.longitude}</p>
        <p><strong>Sat:</strong> ${positionEvent.gps.numero_satelites}</p>
        <p><strong>GpsFix:</strong> ${positionEvent.gps.fixado}</p>
        <p><strong>Ignicao:</strong> ${positionEvent.flags.ignicao}</p>
        <p><strong>PosicaoOnline:</strong>${
          positionEvent.flags.posicao_online
        }</p>
        <p><strong>Velocidade:</strong> ${positionEvent.gps.velocidade}</p>
        <p><strong>OrigemMensagem:</strong> ${
          positionEvent.origem_mensagem ?? ''
        }</p>
        </div>
        `,
      });
    }

    if (marker != undefined) {
      marker.addListener('click', () => {
        infowindow.open({
          anchor: marker,
          shouldFocus: false,
        });
      });
      marker.setMap(this.maps);
      this.markers.push(marker);
    }

    if (markerLoRaP2PAux != undefined) {
      markerLoRaP2PAux.addListener('click', () => {
        infowindowLoRaP2PAux.open({
          anchor: markerLoRaP2PAux,
          shouldFocus: false,
        });
      });
      markerLoRaP2PAux.setMap(this.maps);
      this.markers.push(markerLoRaP2PAux);
    }
  }

  openInfoWindowMap(id: number): void {
    google.maps.event.trigger(this.markers[id], 'click');
  }

  lineBetweenPoints() {
    if (this.lineBetweenMarkers == 0) {
      const grupos: Record<string, google.maps.LatLng[]> = {};
      // Agrupar coordenadas por numero_serie
      this.lineCoordinates.forEach(item => {
        if (!grupos[item.numero_serie]) {
          grupos[item.numero_serie] = [];
        }
        grupos[item.numero_serie].push(item.point);
      });
      // Criar uma polyline para cada grupo
      Object.keys(grupos).forEach(id => {
        const linePath = new google.maps.Polyline({
          path: grupos[id],
          geodesic: true,
          strokeColor: 'black',
          strokeOpacity: 1.0,
          strokeWeight: 2
        });
        linePath.setMap(this.maps);
        this.polylines.push(linePath);
      });
    } else if (this.lineBetweenMarkers == 1) {
      this.lineCoordinatesMessageOriginLatLng.forEach((item: any) => {
        var linePath = new google.maps.Polyline({
          path: item,
          geodesic: true,
          strokeColor: 'black',
        });        
        linePath.setMap(this.maps);
        this.polylines.push(linePath);
      });
    } else if (this.lineBetweenMarkers == 2) {
      this.lineCoordinatesMessageOriginLatLng.forEach((item: any) => {
        var linePath = new google.maps.Polyline({
          path: item,
          geodesic: true,
          strokeColor: 'black',
        });
        this.polylines.push(linePath);
        linePath.setMap(this.maps);
      });
    }
    this.lineCoordinatesMessageOrigin = [];
    this.lineCoordinatesMessageOriginLatLng = [];
  }

  setCenterPositionOnMapAndOpenInfoBox(index: number): void {
    this.maps.setCenter({
      lat: this.positionEventJsonList[index].gps.latitude,
      lng: this.positionEventJsonList[index].gps.longitude,
    });
    this.maps.setZoom(this.zoom);
    this.openInfoWindowMap(index);
  }

  onClickChangeGrid(key: any, subKey: any) {
    if (key != undefined) {
      if (subKey != undefined) {
        this.filterGridEvents[key][subKey] =
          !this.filterGridEvents[key][subKey];
      }
      this.filterGridEvents[key]['all'] = !this.filterGridEvents[key]['all'];
    }

    this.circularProgressiveWait = true;
    this.jsonEventsGrid = this.prepareEventsJson();
    this.circularProgressiveWait = false;
  }
  onClickFilterCheckBoxEventGrid(
    item: any,
    key: string,
    subKey: string,
    value: any
  ) {
    if (key == '') {
      var isDate = subKey.startsWith('data');
      key = subKey.split('.')[0];
      if (isDate) {
        key = 'datas';
      }
      if (Object.keys(item[key]).length == 2) {
        item[key]['all'] = !value;
      } else {
        item[key][subKey] = !value;
      }
    } else {
      item[key][subKey] = !value['currentTarget']['checked'];
    }
    this.onClickChangeGrid(undefined, undefined);
  }

  getFilterEventCountGrid(header: String[]) {
    var filterColumnEventGridAux: any = {};
    header.forEach((element) => {
      const elementSplit = element.replace(',', '.').split('.');
      const key = elementSplit[0];
      const elementJoin = elementSplit.join('.');
      if (element.startsWith('data_')) {
        if (!filterColumnEventGridAux['datas']) {
          filterColumnEventGridAux['datas'] = { all: false };
          filterColumnEventGridAux['datas'][elementJoin] = false;
        } else if (!filterColumnEventGridAux['datas'][elementJoin]) {
          filterColumnEventGridAux['datas'][elementJoin] = false;
        }
      } else if (!filterColumnEventGridAux[key]) {
        filterColumnEventGridAux[key] = { all: false };
        filterColumnEventGridAux[key][elementJoin] = false;
      } else if (!filterColumnEventGridAux[key][elementJoin]) {
        filterColumnEventGridAux[key][elementJoin] = false;
      }
    });
    return filterColumnEventGridAux;
  }

  prepareEventsJson() {
    var headers2: string[] = [];
    if (this.headers.length == 0) {
      this.positionEventJsonList.forEach((event) => {
        this.getFields(event);
      });
    }
    headers2 = this.headers;

    let headersAux = [
      'tipo_evento',
      'data_hora_evento',
      'data_hora_recebimento',
      'data_hora_armazenamento',
      'numero_sequencial',
      'origem_mensagem',
      'rastreador.motivo_envio.0',
      'rastreador.motivo_envio.1',
      'rastreador.motivo_envio.2',
      'flags.ignicao',
      'flags.ignicao_virtual',
      'bateria_externa.tensao',
      'rastreador.bateria_interna.tensao',
      'flags.posicao_online',
      'gps.fixado',
      'gps.numero_satelites',
      'gps.hdop',
      'gps.latitude',
      'gps.longitude',
      'gps.velocidade',
      'gps.proa',
      'gps.odometro',
    ];

    headers2.forEach((item: any) => {
      let notExist = !headersAux.includes(item);
      let filter: boolean | String = false;
      if (Object.keys(this.filterGridEvents).length > 0) {
        var itemSplit = item.replace(',', '.').split('.');
        var isDate = item.startsWith('data');
        var key = itemSplit[0];
        if (isDate) {
          key = 'datas';
        }
        filter = true;
        if (!this.filterGridEvents[key]['all']) {
          filter = false;
          if (this.filterGridEvents[key][item]) {
            filter = true;
          }
        }
      }
      if (!notExist && filter) {
        headersAux = headersAux.filter((e) => {
          return e != item;
        });
      }
      if ((!filter || this.isExportingExcel) && notExist) {
        headersAux.push(item);
      }
    });

    let json: Object[] = [];
    this.positionEventJsonList.forEach((event: any) => {
      let jsonAux: string[] = [];

      headersAux.forEach((header: any) => {
        let field = header.split('.');
        let eventAux = event;
        let eventValue = '"' + header + '":""';
        field.forEach((item: any) => {
          if (item in eventAux) {
            if (item == field[field.length - 1]) {
              eventValue =
                '"' + header + '":"' + eventAux[item].toString() + '"';
            }
            eventAux = eventAux[item];
          }
        });
        jsonAux.push(eventValue);
      });
      json.push(JSON.parse('{' + jsonAux.join(',') + '}'));
    });

    return json;
  }

  //Export Excel
  exportExcel() {
    this.isExportingExcel = true;
    this.filterGridEventsSelect = [];
    var json = this.prepareEventsJson();
    this.isExportingExcel = false;

    import('xlsx').then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(json); // Sale Data
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(
        excelBuffer,
        `${this.positionEventJsonList[0].rastreador.numero_serie}`
      );
    });
  }
  currentDate = new Date();
  month: number = this.currentDate.getMonth() + 1;
  day: number = this.currentDate.getDate();
  year: number = this.currentDate.getFullYear();
  hour: number = this.currentDate.getHours();
  minutes: number = this.currentDate.getMinutes();

  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName +
          '_export_' +
          this.year +
          this.month +
          this.day +
          '_' +
          this.hour +
          this.minutes +
          EXCEL_EXTENSION
      );
    });
  }
  openModal(centerDataModal: any) {
    this.getFieldEvents();
    this.countEventGraphBarMountAndTable(this.graphFieldSelect);
    this.modalInstance = this.modalService.open(centerDataModal, {
      size: 'fullscreen',
      centered: true,
      windowClass: 'modal-holder',
    });
  }

  getValues() {
    var todos = this.selected.find((element) => {
      return element == -1;
    });
  }
  ngAfterViewInit() {
    this.initializeMap();
  }

  private async initializeMap() {
    await this.loader.importLibrary('geometry');
    const { Map } = (await google.maps.importLibrary(
      'maps'
    )) as google.maps.MapsLibrary;

    this.maps = new Map(
      document.getElementById('map') as HTMLElement,
      this.options
    );
  }

  async initMap() {
    this.markers.forEach((item: google.maps.Marker) => {
      item.setMap(null);
    });
    this.markersLoRaWAN.forEach((item: google.maps.Circle) => {
      item.setMap(null);
    });
    this.polylines.forEach((item: google.maps.Polyline) => {
      item.setMap(null);
    });
    this.clearMarker();
    this.markers = [];
    this.markersLoRaWAN = [];
    this.polylines = [];
    this.lineCoordinates = [];
  }

  mountGraphLineGsmGPS(gsm: any, gps: any, rede4g: any) {
    this.lineChartData[0] = [];
    this.lineChartLabels[0] = [];
    var index = [];
    var gsmIndex = 0;
    var rede4gIndex = 0;
    var gpsIndex = 0;
    if (gsm.checked) {
      index.push('');
      gsmIndex = index.length - 1;
      this.lineChartData[0].push({
        data: [],
        label: 'Sinal GSM',
        yAxisID: 'y-gsm-external',
      });
    }
    if (rede4g.checked) {
      index.push('');
      rede4gIndex = index.length - 1;
      this.lineChartData[0].push({
        data: [],
        label: 'Sinal REDE 4G',
        yAxisID: 'y-4g-external',
      });
    }
    if (gps.checked) {
      index.push('');
      gpsIndex = index.length - 1;
      this.lineChartData[0].push({
        data: [],
        label: 'Número Satelites GPS',
        yAxisID: 'y-gps-external',
      });
    }

    this.positionEventJsonList
      .slice()
      .reverse()
      .forEach((eventPosition: any) => {
        let isDetectionP2PEvent = false;
        let isOriginP2PEvent = false;
        if (this.lineChartFilterDetectionP2PGsmGps) {
          eventPosition.tipo_evento == 'DETECCAO_P2P'
            ? (isDetectionP2PEvent = true)
            : null;
        }
        if (this.lineChartFilterOriginP2PGsmGps) {
          eventPosition.origem_mensagem == 'LORA_P2P'
            ? (isOriginP2PEvent = true)
            : null;
        }
        if (!isDetectionP2PEvent && !isOriginP2PEvent) {
          let date = eventPosition.data_hora_evento.split(' ')[0].split('-');
          let hora = eventPosition.data_hora_evento.split(' ')[1];
          date = new Date(`${date[2]}-${date[1]}-${date[0]} ${hora}`);

          this.lineChartLabels[0].push(date);
          let gsmAux = undefined;
          let rede4gAux = undefined;
          let gpsAux = undefined;
          try {
            if (gsm.checked && eventPosition.origem_mensagem == 'GSM') {
              gsmAux = eventPosition.gsm.qualidade_sinal;
            }
          } catch (error) {}
          try {
            if (rede4g.checked && eventPosition.origem_mensagem == 'REDE_4G') {
              rede4gAux = eventPosition.gsm.qualidade_sinal;
            }
          } catch (error) {}
          try {
            if (gps.checked) {
              gpsAux = eventPosition.gps.numero_satelites;
            }
          } catch (error) {}
          this.lineChartData[0][gsmIndex].data.push(gsmAux);
          this.lineChartData[0][rede4gIndex].data.push(rede4gAux);
          this.lineChartData[0][gpsIndex].data.push(gpsAux);
        }
      });
  }
  mountGraphLineArrivedData() {
    this.lineChartData[2] = [];
    this.lineChartLabels[2] = [];
    var index = [];
    var eventIndex = 0;
    var receivedIndex = 0;
    var storageIndex = 0;

    index.push('');
    eventIndex = index.length - 1;
    this.lineChartData[2].push({
      data: [],
      label: 'Evento',
      yAxisID: 'y',
    });
    index.push('');
    receivedIndex = index.length - 1;
    this.lineChartData[2].push({
      data: [],
      label: 'Recebimento',
      yAxisID: 'y',
    });
    index.push('');
    storageIndex = index.length - 1;
    this.lineChartData[2].push({
      data: [],
      label: 'Armazenamento',
      yAxisID: 'y',
    });

    this.positionEventJsonList
      .slice()
      .reverse()
      .forEach((eventPosition: any) => {
        let isDetectionP2PEvent = false;
        let isOriginP2PEvent = false;
        if (this.lineChartFilterDetectionP2PGsmGps) {
          eventPosition.tipo_evento == 'DETECCAO_P2P'
            ? (isDetectionP2PEvent = true)
            : null;
        }
        if (this.lineChartFilterOriginP2PGsmGps) {
          eventPosition.origem_mensagem == 'LORA_P2P'
            ? (isOriginP2PEvent = true)
            : null;
        }
        if (!isDetectionP2PEvent && !isOriginP2PEvent) {
          let date = eventPosition.data_hora_evento.split(' ')[0].split('-');
          let hora = eventPosition.data_hora_evento.split(' ')[1];
          let dateEvent = new Date(`${date[2]}-${date[1]}-${date[0]} ${hora}`);
          let timestampEvent = dateEvent.getTime() / 1000;
          date = eventPosition.data_hora_recebimento.split(' ')[0].split('-');
          hora = eventPosition.data_hora_recebimento.split(' ')[1];
          let dateReceveid = new Date(
            `${date[2]}-${date[1]}-${date[0]} ${hora}`
          );
          let timestampReceveid = dateReceveid.getTime() / 1000;
          date = eventPosition.data_hora_armazenamento.split(' ')[0].split('-');
          hora = eventPosition.data_hora_armazenamento.split(' ')[1];
          let dateStorage = new Date(
            `${date[2]}-${date[1]}-${date[0]} ${hora}`
          );
          let timestampStorage = dateStorage.getTime() / 1000;

          let eventAux = timestampEvent / 60 - timestampReceveid / 60;
          let receivedAux = 0;
          let storageAux = timestampStorage / 60 - timestampReceveid / 60;

          this.lineChartLabels[2].push(dateEvent);
          this.lineChartData[2][eventIndex].data.push(Math.round(eventAux));
          this.lineChartData[2][receivedIndex].data.push(receivedAux);
          this.lineChartData[2][storageIndex].data.push(Math.round(storageAux));
        }
      });
  }
  mountGraphLineUBI(speedGPS: any, rpm: any, speedCAN: any) {
    this.lineChartData[1] = [];
    this.lineChartLabels[1] = [];
    var index = [];
    var speedGPSIndex = 0;
    var speedCANIndex = 0;
    var rpmIndex = 0;
    if (speedGPS.checked) {
      index.push('');
      speedGPSIndex = index.length - 1;
      this.lineChartData[1].push({
        data: [],
        label: 'Velocidade GPS',
        yAxisID: 'y-speed-gps',
      });
    }
    if (speedCAN.checked) {
      index.push('');
      speedCANIndex = index.length - 1;
      this.lineChartData[1].push({
        data: [],
        label: 'Velocidade CAN',
        yAxisID: 'y-speed-can',
      });
    }
    if (rpm.checked) {
      index.push('');
      rpmIndex = index.length - 1;
      this.lineChartData[1].push({
        data: [],
        label: 'RPM',
        yAxisID: 'y-rpm-external',
      });
    }

    this.positionEventJsonList
      .slice()
      .reverse()
      .forEach((eventPosition: any) => {
        if (!['LORA_P2P', 'LORA_WAN'].includes(eventPosition.origem_mensagem)) {
          let date = eventPosition.data_hora_evento.split(' ')[0].split('-');
          let hora = eventPosition.data_hora_evento.split(' ')[1];
          date = new Date(`${date[2]}-${date[1]}-${date[0]} ${hora}`);

          this.lineChartLabels[1].push(date);

          try {
            let speedGPSAux = undefined;
            let speedCANAux = undefined;
            let rpmAux = undefined;
            try {
              if (eventPosition.gps.fixado) {
                speedGPSAux = eventPosition.gps.velocidade;
              }
            } catch (error) {}
            try {
              speedCANAux = eventPosition.can.sensores.velocidade;
            } catch (error) {}
            try {
              rpmAux = eventPosition.can.sensores.rpm;
            } catch (error) {}
            this.lineChartData[1][speedGPSIndex].data.push(speedGPSAux);
            this.lineChartData[1][speedCANIndex].data.push(speedCANAux);
            this.lineChartData[1][rpmIndex].data.push(rpmAux);
          } catch (error) {}
        }
      });
  }

  formatXAxisLabel(date: Date): string {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }
  mountGraphLineBattery() {
    let fieldsIndex = {
      externalBat: 0,
      internalBat: 0,
      internalBatEstimatedTime: 0,
      'ign-on': 0,
      'ign-off': 0,
      'Bat-Ext-Reconnect': 0,
      'Bat-Ext-Disconnect': 0,
    };
    this.lineChartDataBattery = [];
    this.lineChartLabelsBattery = [];
    this.lineChartDataBattery.push({
      data: [],
      label: 'Bat.Externa',
      yAxisID: 'y-bat-external',
    });
    fieldsIndex['externalBat'] = this.lineChartDataBattery.length - 1;

    if (this.lineChartFilterInternalBattery) {
      this.lineChartDataBattery.push({
        data: [],
        label: this.lineChartFilterPercentBattery
          ? 'Bat.Interna (%)'
          : 'Bat.Interna',
        yAxisID: 'y-bat-internal',
      });
      fieldsIndex['internalBat'] = this.lineChartDataBattery.length - 1;
    }

    if (this.lineChartFilterTimeEstimatedBattery) {
      this.lineChartDataBattery.push({
        data: [],
        label: 'Tempo estimado (h)',
        yAxisID: 'y-time-estimated',
      });
      fieldsIndex['internalBatEstimatedTime'] =
        this.lineChartDataBattery.length - 1;
    }

    ///
    if (this.lineChartBatteryIgn) {
      this.lineChartDataBattery.push({
        data: [],
        label: 'Ignicao ON',
        //      yAxisID: 'y-ign-on',
      });
      fieldsIndex['ign-on'] = this.lineChartDataBattery.length - 1;
      this.lineChartDataBattery.push({
        data: [],
        label: 'Ignicao OFF',
        //  yAxisID: 'y-ign-off',
      });
      fieldsIndex['ign-off'] = this.lineChartDataBattery.length - 1;
    }

    if (this.lineChartDeconectBattery) {
      this.lineChartDataBattery.push({
        data: [],
        label: 'Bat.Ext. Desconectada',
        //      yAxisID: 'y-ign-on',
      });
      fieldsIndex['Bat-Ext-Reconnect'] = this.lineChartDataBattery.length - 1;
      this.lineChartDataBattery.push({
        data: [],
        label: 'Bat.Ext. Reconectada',
        //  yAxisID: 'y-ign-off',
      });
      fieldsIndex['Bat-Ext-Disconnect'] = this.lineChartDataBattery.length - 1;
    }
    ///

    this.positionEventJsonList
      .slice()
      .reverse()
      .forEach((event) => {
        let isDetectionP2PEvent = false;
        let isOriginP2PEvent = false;

        if (this.lineChartFilterDetectionP2PBattery) {
          event.tipo_evento == 'DETECCAO_P2P'
            ? (isDetectionP2PEvent = true)
            : null;
        }
        if (this.lineChartFilterOriginP2PBattery) {
          event.origem_mensagem == 'LORA_P2P'
            ? (isOriginP2PEvent = true)
            : null;
        }
        if (!isDetectionP2PEvent && !isOriginP2PEvent) {
          try {
            let batteryExternal = event.bateria_externa?.tensao;
            let baterryInternalValue = this.lineChartFilterPercentBattery
              ? event.rastreador.bateria_interna?.porcentagem
              : event.rastreador.bateria_interna?.tensao;
            let date = event.data_hora_evento.split(' ')[0].split('-');
            let hora = event.data_hora_evento.split(' ')[1];
            // date = this.datePipe.transform(
            //   new Date(`${date[2]}-${date[1]}-${date[0]} ${hora}`),
            //   'dd/MM/yyyy HH:mm:ss'
            // );
            date = new Date(`${date[2]}-${date[1]}-${date[0]} ${hora}`);

            this.lineChartLabelsBattery.push(date);
            this.lineChartDataBattery[fieldsIndex.externalBat].data.push(
              batteryExternal
            );

            if (this.lineChartFilterInternalBattery)
              this.lineChartDataBattery[1].data.push(baterryInternalValue);

            if (this.lineChartFilterTimeEstimatedBattery)
              this.lineChartDataBattery[
                fieldsIndex.internalBatEstimatedTime
              ].data.push(
                event.rastreador.bateria_interna?.horas_estimadas_restante
              );

            if (this.lineChartBatteryIgn) {
              if (event.tipo_evento == 'IGNICAO_ON') {
                this.lineChartDataBattery[fieldsIndex['ign-on']].data.push(1);
              } else {
                this.lineChartDataBattery[fieldsIndex['ign-on']].data.push(
                  null
                );
              }
              if (event.tipo_evento == 'IGNICAO_OFF') {
                this.lineChartDataBattery[fieldsIndex['ign-off']].data.push(1);
              } else {
                this.lineChartDataBattery[fieldsIndex['ign-off']].data.push(
                  null
                );
              }
            }
            if (this.lineChartDeconectBattery) {
              if (event.tipo_evento == 'BATERIA_EXTERNA_RECONECTADA') {
                this.lineChartDataBattery[
                  fieldsIndex['Bat-Ext-Reconnect']
                ].data.push(1);
              } else {
                this.lineChartDataBattery[
                  fieldsIndex['Bat-Ext-Reconnect']
                ].data.push(null);
              }
              if (event.tipo_evento == 'BATERIA_EXTERNA_DESCONECTADA') {
                this.lineChartDataBattery[
                  fieldsIndex['Bat-Ext-Disconnect']
                ].data.push(1);
              } else {
                this.lineChartDataBattery[
                  fieldsIndex['Bat-Ext-Disconnect']
                ].data.push(null);
              }
            }
          } catch (error) {}
        }
      });
  }

  getFields(event: any): any {
    let options: string[] = [];
    Object.entries(event).forEach((item: any) => {
      let key: string[] = [];
      item.forEach((itemAux: any) => {
        switch (typeof itemAux) {
          case 'string':
            if (itemAux == item[0]) key.push(itemAux);
            if (itemAux == item[0] && typeof item[1] != 'object')
              options.push(itemAux);
            break;
          case 'object':
            Object.entries(itemAux).forEach((subItem: any) => {
              subItem.forEach((subItemAux: any) => {
                switch (typeof subItemAux) {
                  case 'string':
                    if (
                      subItemAux == subItem[0] &&
                      typeof subItem[1] != 'object'
                    ) {
                      options.push(item[0] + '.' + subItemAux);
                    }
                    break;
                  //@ts-ignore
                  case 'object':
                    Object.entries(subItemAux).forEach((subsubItem: any) => {
                      subsubItem.forEach((subsubItemAux: any) => {
                        switch (typeof subsubItemAux) {
                          case 'string':
                            if (
                              subsubItemAux == subsubItem[0] &&
                              typeof subsubItem[1] != 'object'
                            ) {
                              options.push(
                                item[0] + '.' + subItem[0] + '.' + subsubItemAux
                              );
                            }
                            break;
                          default:
                            break;
                        }
                      });
                    });
                  default:
                    break;
                }
              });
            });
            break;
          default:
            break;
        }
      });
    });
    options.forEach((item) => {
      if (!this.headers.includes(item)) {
        this.headers.push(item);
      }
    });
    this.filterGridEvents = this.getFilterEventCountGrid(this.headers);
  }

  getFieldEvents() {
    this.headers = [];
    this.positionEventJsonList.forEach((event) => {
      this.getFields(event);
    });
    this.graphField = this.headers.sort((obj1, obj2) => {
      if (obj1 > obj2) {
        return 1;
      } else if (obj1 < obj2) {
        return -1;
      }
      return 0;
    });
  }
  changeFlagButtonFilterSequenceNumber(item: any) {
    this.filterSequenceNumber = item._checked;
  }
  countEventGraphBarMountAndTable(fieldSelect: string) {
    this.barChartData = [];
    this.barChartLabels = [];
    this.countEventTable = [];
    this.lineChartDataBattery = [];
    this.lineChartLabelsBattery = [];
    this.lineChartData = [];
    this.lineChartLabels = [];
    this.tableCountEventHTMLString = '';
    var tableCountEventHTML = [
      '<div> <table class="table table-fit table-hover">',
    ];
    var field = fieldSelect.split('.');
    var eventTypeAux: string[] = [];
    var dateHeaders: string[] = [];
    var eventsHeaders: string[] = [];
    let sequenceFilter: any[] = [];
    this.positionEventJsonList.forEach((event) => {
      let eventAux = event;
      var eventString: string = '';
      let isRepeatPosition = false;
      let existNumberSequenceKey = Object.keys(event).includes(
        'numero_sequencial'
      )
        ? true
        : false;

      if (existNumberSequenceKey && this.filterSequenceNumber) {
        let time = event.data_hora_evento.split(' ')[1];
        let dateSplit = event.data_hora_evento.split(' ')[0].split('-');
        let dateTimeEpoch =
          new Date(
            `${dateSplit[1]}-${dateSplit[0]}-${dateSplit[2]} ${time}`
          ).getTime() * 1;
        let sequenceFilterTextSub1 = `${event.origem_mensagem}${
          dateTimeEpoch - 1000
        }${event.tipo_evento}${event.numero_sequencial}`;
        let sequenceFilterText = `${event.origem_mensagem}${dateTimeEpoch}${event.tipo_evento}${event.numero_sequencial}`;
        let sequenceFilterTextAdd1 = `${event.origem_mensagem}${
          dateTimeEpoch + 1000
        }${event.tipo_evento}${event.numero_sequencial}`;
        if (sequenceFilter.includes(sequenceFilterText)) {
          isRepeatPosition = true;
          sequenceFilter.push(sequenceFilterTextSub1);
          sequenceFilter.push(sequenceFilterText);
          sequenceFilter.push(sequenceFilterTextAdd1);
        } else {
          sequenceFilter.push(sequenceFilterTextSub1);
          sequenceFilter.push(sequenceFilterText);
          sequenceFilter.push(sequenceFilterTextAdd1);
        }
      }
      if (!isRepeatPosition || !this.filterSequenceNumber) {
        field.forEach((item: any) => {
          if (item in eventAux) {
            if (item == field[field.length - 1]) {
              eventString = eventAux[item].toString();
            }
            eventAux = eventAux[item];
          }
        });

        var dateEvent: string = event.data_hora_evento.split(' ')[0];

        var indexDate = this.countEventTable.findIndex((valueDateObj) => {
          return valueDateObj.date == dateEvent;
        });
        if (indexDate > -1) {
          var indexEvent = this.countEventTable[indexDate].events.findIndex(
            (valueEventObj) => {
              return valueEventObj.name.toString() == eventString;
            }
          );
          if (indexEvent > -1) {
            this.countEventTable[indexDate].events[indexEvent].qtd =
              this.countEventTable[indexDate].events[indexEvent].qtd + 1;
          } else {
            if (eventsHeaders.indexOf(eventString) < 0) {
              eventsHeaders.push(eventString);
            }
            this.countEventTable[indexDate].events.push({
              name: eventString,
              qtd: 1,
            });
          }
        } else {
          if (eventsHeaders.indexOf(eventString) < 0) {
            eventsHeaders.push(eventString);
          }
          dateHeaders.push(dateEvent);
          this.countEventTable.push({
            date: dateEvent,
            events: [{ name: eventString, qtd: 1 }],
          });
        }

        if (
          eventTypeAux.filter((value) => {
            return value == eventString;
          }).length > 0
        ) {
          this.barChartData
            .filter((label) => {
              return label.label == eventString;
            })
            .map((obj) => {
              var a = Number(obj.data[0]);
              obj.data[0] = a + 1;
            });
        } else {
          eventTypeAux.push(eventString);

          this.barChartData.push({
            data: [1],
            label: eventString,
          });
        }
      }
    });

    this.barChartLabels.push(
      this.positionEventJsonList[0].rastreador.numero_serie
    );

    tableCountEventHTML.push(
      '<thead class="table-primary"><tr ><th scope="col">#</th>'
    );
    dateHeaders.forEach((date) => {
      tableCountEventHTML.push(
        '<th scope="col"><div><strong>' + date + '</strong></div></th>'
      );
    });
    tableCountEventHTML.push(
      '<th scope="col"><div><strong> Total</strong> </div></th>'
    );

    tableCountEventHTML.push('</tr></thead>');

    var sumEventDate: number[] = [];
    var sumTotal = 0;
    try {
      eventsHeaders = eventsHeaders.sort((obj1, obj2) => {
        if (obj1 > obj2) {
          return 1;
        } else if (obj1 < obj2) {
          return -1;
        }
        return 0;
      });
    } catch (error) {}

    eventsHeaders.forEach((event) => {
      var sumEvent = 0;
      var dateIndexSumEvent = 0;
      tableCountEventHTML.push('<tr>');
      tableCountEventHTML.push(
        '<th scope="row"><strong>' + event + '<strong></th>'
      );
      dateHeaders.forEach((date) => {
        if (sumEventDate.length < dateHeaders.length) {
          sumEventDate.push(0);
        }
        var indexDate = this.countEventTable.findIndex((dateObj: any) => {
          return dateObj.date == date;
        });

        var indexEvent = this.countEventTable[indexDate].events.findIndex(
          (eventObj: any) => {
            return eventObj.name == event;
          }
        );
        if (indexEvent > -1) {
          tableCountEventHTML.push(
            '<td>' +
              this.countEventTable[indexDate].events[indexEvent].qtd +
              '</td>'
          );

          sumEvent =
            sumEvent + this.countEventTable[indexDate].events[indexEvent].qtd;
          sumEventDate[dateIndexSumEvent] =
            sumEventDate[dateIndexSumEvent] +
            this.countEventTable[indexDate].events[indexEvent].qtd;
          sumTotal =
            sumTotal + this.countEventTable[indexDate].events[indexEvent].qtd;
        } else {
          tableCountEventHTML.push('<td>' + 0 + '</td>');

          sumEventDate[dateIndexSumEvent] = sumEventDate[dateIndexSumEvent] + 0;

          sumTotal = sumTotal + 0;
        }
        dateIndexSumEvent = dateIndexSumEvent + 1;
      });
      tableCountEventHTML.push('<td><strong>' + sumEvent + '</strong></td>');
      tableCountEventHTML.push('</tr>');
    });

    tableCountEventHTML.push(
      '<tr><th scope="row"><strong> Total</strong> </th>'
    );
    sumEventDate.forEach((dateCount) => {
      tableCountEventHTML.push('<td>' + dateCount + '</td>');
    });
    tableCountEventHTML.push('<td><strong>' + sumTotal + '</strong></td>');

    tableCountEventHTML.push('</tr>');

    tableCountEventHTML.push('</table></div>');

    tableCountEventHTML.forEach((value) => {
      this.tableCountEventHTMLString = this.tableCountEventHTMLString + value;
    });
    var content = document.getElementById('tableCountEventHTMLString');
    if (content) {
      if (content.innerHTML) {
        content.innerHTML = this.tableCountEventHTMLString;
      }
    }
  }

  // ERBS

  getErbs() {
    this.erbsFlag = !this.erbsFlag;
    this.clearMarker();
    if (this.erbsFlag) {
      this.circularProgressiveWait = true;
      let erbsList: Erb[] = [];
      let datetime = '';
      let sequential = '';
      if (Object.keys(this.positionEventJsonList[0]).includes('erbs')) {
        datetime = this.positionEventJsonList[0].data_hora_evento;
        sequential = this.positionEventJsonList[0].numero_sequencial ?? -1;
        this.positionEventJsonList[0].erbs.forEach((itemErb: any) => {
          let erb = new Erb();
          erb.cellid = itemErb.cellid;
          erb.lac = itemErb.lac;
          erb.mnc = itemErb.mnc;
          erb.mcc = itemErb.mcc;
          erb.ta = itemErb.ta;
          erb.rssi = itemErb.rssi;
          erbsList.push(erb);
        });
      } else {
        this.positionEventJsonList.forEach((itemPosition: any) => {
          datetime = itemPosition.data_hora_evento;
          sequential = itemPosition.numero_sequencial ?? -1;
          if (Object.keys(itemPosition).includes('erbs')) {
            itemPosition.erbs.forEach((itemErb: any) => {
              let erb = new Erb();
              erb.cellid = itemErb.cellid;
              erb.lac = itemErb.lac;
              erb.mnc = itemErb.mnc;
              erb.mcc = itemErb.mcc;
              erb.ta = itemErb.ta;
              erb.rssi = itemErb.rssi;
              erbsList.push(erb);
            });
          }
        });
      }
      this.erbService.getErbs(erbsList).subscribe((response: any) => {
        response;
        if (response.length > 0) {
          response.forEach((erb: Erb) => {
            this.createMarkerERB(erb, datetime, sequential);
          });

          this.maps.setCenter({
            lat: Number(response[response.length - 1].lat),
            lng: Number(response[response.length - 1].lng),
          });
        }
        this.circularProgressiveWait = false;
      });
    }
  }

  clearMarker() {
    this.markersTowers.forEach((item: google.maps.Marker) => {
      item.setMap(null);
    });
    this.towersCircle.forEach((item: google.maps.Circle) => {
      item.setMap(null);
    });
    this.towersAzimuth.forEach((item: google.maps.Polygon) => {
      item.setMap(null);
    });
    this.markersTowers = [];
    this.towersCircle = [];
    this.towersAzimuth = [];
  }

  calculateDistanceERB(ta: number): number {
    // usado média das frequencia 2g possíveis
    // return Radius
    let frequency = 1360000000;
    let lightSpeed = 299792458;

    if (ta == -1 || ta == 0) {
      ta = 100;
    }
    return (ta * lightSpeed) / (2 * frequency);
  }

  createConeInCircleMarker(
    circleMarker: google.maps.Circle,
    radius: number,
    angle: number
  ): google.maps.Polygon {
    const center =
      circleMarker.getCenter() ?? new google.maps.LatLng(0, 0, false);

    const latLng = google.maps.geometry.spherical.computeOffset(
      center,
      circleMarker.getRadius(),
      angle
    );
    const d = google.maps.geometry.spherical.computeDistanceBetween(
      center,
      latLng
    );
    //  const h = Math.sqrt(Math.pow(d, 2) - Math.pow(radius, 2));
    const angle1 =
      (angle + 40 / Math.PI) * Math.asin(Math.fround(radius) / Math.fround(d));
    const angle2 =
      (angle - 40 / Math.PI) * Math.asin(Math.fround(radius) / Math.fround(d));
    const tangent1 = google.maps.geometry.spherical.computeOffset(
      center,
      circleMarker.getRadius(),
      angle1
    );
    const tangent2 = google.maps.geometry.spherical.computeOffset(
      center,
      circleMarker.getRadius(),
      angle2
    );
    const cone = new google.maps.Polygon({
      paths: [center, tangent1, tangent2, center],
      strokeColor: '#2ef81b',
      strokeOpacity: 0.5,
      strokeWeight: 2,
      fillColor: '#2ef81b',
      fillOpacity: 0.05,
    });
    return cone;
  }

  createMarkerERB(erb: Erb, datetime: string, sequential: string) {
    let infowindow: any;

    const marker = new google.maps.Marker({
      position: {
        lat: Number(erb.lat),
        lng: Number(erb.lng),
      },
      icon: '../../../../assets/images/tower.png',
    });
    infowindow = new google.maps.InfoWindow({
      content: `<p><strong>dataHoraEvento:</strong> ${datetime}</p>
                <p><strong>Num.Sequencial:</strong> ${sequential}</p>
                <p><strong>lat lng:</strong><span style="color: #ff0000;"><strong>${erb.lat},${erb.lng}</strong></span></p>
                <p><strong>Base de informação:</strong> ${erb.base_erb}</p>
                <p><strong>cellid:</strong> ${erb.cellid}</p>
                <p><strong>lac:</strong> ${erb.lac}</p>
                <p><strong>mcc:</strong> ${erb.mcc}</p>
                <p><strong>mnc:</strong> ${erb.mnc}</p>
                <p><strong>TA:</strong> ${erb.ta}</p>
                <p><strong>rssi:</strong> ${erb.rssi}</p>
                `,
    });

    let radius = (this.calculateDistanceERB(erb.ta ?? -1) * 1000) / 2;
    console.log(radius);
    const towerCircle = new google.maps.Circle({
      strokeColor: '#FF0000',
      strokeOpacity: 0.5,
      strokeWeight: 1,
      fillColor: '#FF0000',
      fillOpacity: 0.15,
      center: marker.getPosition(),
      radius: radius,
    });

    const cone = this.createConeInCircleMarker(
      towerCircle,
      Number(radius),
      Number(erb.azimuth) ?? 0
    );
    cone.setMap(this.maps);
    this.towersAzimuth.push(cone);

    marker.addListener('click', () => {
      infowindow.open({
        anchor: marker,
        shouldFocus: false,
      });
    });
    towerCircle.setMap(this.maps);
    marker.setMap(this.maps);
    this.markersTowers.push(marker);
    this.towersCircle.push(towerCircle);
  }
}
interface countEventTable {
  date: string;
  events: [{ name: string; qtd: number }];
}

interface marker {
  lat: number;
  lng: number;
  label?: string;
  UrlIcon: string;
  proa: number;
}

interface LineCoordinate {
  numero_serie: number | string; 
  point: google.maps.LatLng;
};
